import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './Home';
import FriendZoneLanding from "./friendzone/pages/friendZoneLanding"

import { BrowserRouter, Routes, Route } from "react-router-dom";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
               <Route path="/friendzone" element={<FriendZoneLanding />} />
            </Routes>
        </BrowserRouter>
    );
}

ReactDOM.render(
    <App />, document.getElementById("root")
);
